/* Wordpress Contact Form 7 specific code */

// use HTML 5 native validation
document.querySelectorAll('.wpcf7-form').forEach((form) => {
	form.removeAttribute('novalidate');
});

document
	.querySelectorAll('.wpcf7-form [aria-required="true"]')
	.forEach((element) => {
		element.setAttribute('required', '');
	});

// Link errors to fields
document.querySelectorAll('.wpcf7-not-valid-tip').forEach((error, index) => {
	var id = 'form-error-' + (index + 1);

	error.removeAttribute('role');
	error.setAttribute('id', id);
	error.previousElementSibling.setAttribute('aria-describedby', id);
});

if (document.querySelector('.wpcf7-form.invalid')) {
	document.title = 'Erreurs dans la saisie - ' + document.title;
}

document.querySelectorAll('.wpcf7 .screen-reader-response').forEach((alert) => {
	const list = alert.querySelector('ul');

	if (list) {
		// dot not show the list of errors first, show them inline only
		list.remove();
	}
});
/* end Wordpress Contact Form 7 specific code */

/**
 * Material Design Form Effects
 */
document.addEventListener('DOMContentLoaded', function () {
	const formFields = document.querySelectorAll('.Form-field');

	formFields.forEach((field) => {
		const label = field.querySelector('label');
		const input = field.querySelector('input, textarea, select');

		if (label && input) {
			if (input.type === 'textarea') {
				field.classList.add('is-textarea');
			}

			if (input.value) {
				field.classList.add('has-value');
			}

			input.addEventListener('focus', () => {
				field.classList.add('is-focused');
			});

			input.addEventListener('blur', () => {
				field.classList.remove('is-focused');
				if (input.value) {
					field.classList.add('has-value');
				} else {
					field.classList.remove('has-value');
				}
			});

			input.addEventListener('input', () => {
				if (input.value) {
					field.classList.add('has-value');
				} else {
					field.classList.remove('has-value');
				}
			});
		}
	});
});
